import React from 'react';
import {inject, observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';

import './styles.scss';

interface LayoutProps {
    translate: (key: string) => string;
}

const mapStoresToProps = (stores: any) => ({
    translate: stores.embeddedDashboardGeneralErrorStore.localizationService.translate.bind(
        stores.embeddedDashboardGeneralErrorStore.localizationService
    )
});

@inject(mapStoresToProps)
@observer
export class EmbeddedDashboardGeneralErrorLayoutComponent extends TechseeBaseComponent<LayoutProps> {
    renderInternal() {
        this.addCssClass('general-error');

        const {translate} = this.props;

        return (
            <div className={this.renderCssClasses()}>
                <div className='error-title'>{translate('DASHBOARD_MINI.SOMETHING_WENT_WRONG')}</div>
                <div className='error-text'>{translate('DASHBOARD_MINI.GENERAL_ERROR')}</div>
            </div>
        );
    }
}

export default EmbeddedDashboardGeneralErrorLayoutComponent;
